/* Scelta omaggio e collegamento delle righe. I prezzi li calcola Shopify. */
(function () {
  'use strict';
  if (window.TaibiGifts) return;
  var sequence = 0;
  function cartURL() { return window.routes.cart_url + '.js'; }
  async function readCart() {
    var response = await fetch(cartURL(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Impossibile leggere il carrello.');
    return response.json();
  }
  async function change(body) {
    var response = await fetch(window.routes.cart_change_url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
    var state = await response.json();
    if (!response.ok || state.errors || state.status) throw new Error(state.description || state.errors || 'Quantità non disponibile.');
    return state;
  }
  function rowsInGroup(cart, group) {
    return (cart.items || []).filter(function (item) { return item.properties && item.properties._taibi_gift_group === group; });
  }
  async function removeGroup(group, cart) {
    cart = cart || await readCart();
    var rows = rowsInGroup(cart, group);
    while (rows.length) {
      var next = rows.find(function (row) { return row.properties._taibi_gift_role === 'gift'; }) || rows[0];
      var previousCount = rows.reduce(function (sum, row) { return sum + row.quantity; }, 0);
      cart = await change({ id: next.key, quantity: 0 });
      rows = rowsInGroup(cart, group);
      if (rows.reduce(function (sum, row) { return sum + row.quantity; }, 0) >= previousCount) throw new Error('Impossibile rimuovere il kit e gli omaggi. Riprova.');
    }
    return cart;
  }
  function giftsAreFree(rows) {
    return rows.length > 0 && rows.every(function (row) { return row.final_line_price === 0; });
  }
  function giftsMatch(rows, items) {
    return giftsAreFree(rows) && rows.every(function (row) {
      return items.some(function (item) { return String(row.variant_id) === String(item.id); });
    }) && items.every(function (item) {
      return rows.filter(function (row) { return String(row.variant_id) === String(item.id); })
        .reduce(function (sum, row) { return sum + row.quantity; }, 0) === item.quantity;
    });
  }
  function giftPlan(parent, rows) {
    var plan;
    try { plan = JSON.parse(parent.properties._taibi_gift_items || 'null'); } catch (_) { plan = null; }
    if (Array.isArray(plan) && plan.length && plan.every(function (item, i) {
      return item.id && Number.isInteger(item.ratio) && item.ratio > 0 &&
        plan.findIndex(function (other) { return String(other.id) === String(item.id); }) === i;
    })) return plan;
    var gift = rows.find(function (item) { return item.properties._taibi_gift_role === 'gift'; });
    return gift ? [{ id: gift.variant_id, ratio: Math.max(1, parseInt(parent.properties._taibi_gift_ratio, 10) || 1) }] : [];
  }
  async function updateGiftRows(group, state, quantity, plan) {
    if (!plan.length) throw new Error('Omaggio non disponibile.');
    for (var item of plan) {
      var matching = function (row) { return row.properties._taibi_gift_role === 'gift' && String(row.variant_id) === String(item.id); };
      var gifts = rowsInGroup(state, group).filter(matching);
      if (!gifts.length) throw new Error('Omaggio non disponibile.');
      // Consolidate discount splits only within the same gift variant.
      while (gifts.length > 1) {
        state = await change({ id: gifts[gifts.length - 1].key, quantity: 0 });
        gifts = rowsInGroup(state, group).filter(matching);
      }
      if (!gifts.length) throw new Error('Omaggio non disponibile.');
      state = await change({ id: gifts[0].key, quantity: quantity * item.ratio });
    }
    var expected = plan.map(function (item) { return { id: item.id, quantity: quantity * item.ratio }; });
    if (!giftsMatch(rowsInGroup(state, group).filter(function (row) { return row.properties._taibi_gift_role === 'gift'; }), expected)) {
      throw new Error('Lo sconto o la quantità degli omaggi non sono disponibili per questa quantità.');
    }
    return state;
  }
  async function withSections(cart, body) {
    if (!body.sections || !body.sections.length) return cart;
    var sections = Array.isArray(body.sections) ? body.sections.join(',') : body.sections;
    var url = new URL(body.sections_url || window.location.pathname, window.location.href);
    url.searchParams.set('sections', sections);
    var response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Impossibile aggiornare il carrello.');
    cart.sections = await response.json();
    return cart;
  }
  async function changeCart(body, key) {
    body = Object.assign({}, body, { quantity: Number(body.quantity) });
    if (!Number.isInteger(body.quantity) || body.quantity < 0) throw new Error('Quantità non valida.');
    var before = await readCart();
    var target = key ? before.items.find(function (item) { return item.key === key; }) : before.items[body.line - 1];
    var group = target && target.properties && target.properties._taibi_gift_group;
    if (!target) return withSections(before, body);
    if (!group) return change(Object.assign({}, body, { id: target.key, line: undefined }));
    var rows = rowsInGroup(before, group);
    var parent = rows.find(function (item) { return item.properties._taibi_gift_role === 'kit'; });
    if (!parent || (body.quantity === 0 && target.properties._taibi_gift_role !== 'gift')) return withSections(await removeGroup(group, before), body);
    if (target.properties._taibi_gift_role === 'gift') {
      before.taibi_notice = 'Modifica la quantità del kit per aggiornare anche gli omaggi.';
      return withSections(before, body);
    }
    var plan = giftPlan(parent, rows);
    var state;
    try {
      state = await change({ id: parent.key, quantity: body.quantity });
      var currentParent = rowsInGroup(state, group).find(function (item) { return item.properties._taibi_gift_role === 'kit'; });
      if (!currentParent) return withSections(await removeGroup(group, state), body);
      state = await updateGiftRows(group, state, currentParent.quantity, plan);
    } catch (error) {
      // Recover the previous kit and its gifts when an update fails.
      // Only this group is touched; independently purchased lines are preserved.
      try {
        state = await readCart();
        var previousParent = rowsInGroup(state, group).find(function (item) { return item.properties._taibi_gift_role === 'kit'; });
        if (!previousParent) throw new Error('Kit non disponibile.');
        state = await change({ id: previousParent.key, quantity: parent.quantity });
        state = await updateGiftRows(group, state, parent.quantity, plan);
        var restoredParent = rowsInGroup(state, group).find(function (item) { return item.properties._taibi_gift_role === 'kit'; });
        if (!restoredParent || restoredParent.quantity !== parent.quantity) throw new Error('Offerta non disponibile.');
        state.taibi_notice = error.message;
      } catch (restoreError) {
        state = await removeGroup(group);
        state.taibi_notice = error.message + ' Il kit e i relativi omaggi sono stati rimossi; puoi aggiungerli di nuovo.';
      }
    }
    return withSections(state, body);
  }
  window.TaibiGifts = { changeCart: changeCart };

  if (customElements.get('taibi-gift-picker')) return;
  class TaibiGiftPicker extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.productInfo = this.closest('product-info');
      var script = this.querySelector('[data-gift-kit-quantities]');
      try { this.quantities = JSON.parse(script ? script.textContent : '{}'); } catch (error) { this.quantities = {}; }
      this.onChange = this.handleChange.bind(this);
      this.onClick = this.handleClick.bind(this);
      this.onProductChange = this.handleProductChange.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      if (this.productInfo) {
        this.productInfo.addEventListener('change', this.onProductChange);
        this.productInfo.addEventListener('input', this.onProductChange);
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.sync.bind(this));
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.sync.bind(this));
      }
      if (!this.singleTitle) this.singleTitle = this.querySelector('.taibi-gifts__title').textContent;
      if (this.singleValue === undefined) this.singleValue = this.selected && this.selected.value;
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      if (this.productInfo) {
        this.productInfo.removeEventListener('change', this.onProductChange);
        this.productInfo.removeEventListener('input', this.onProductChange);
      }
      if (this.unsubscribeQuantity) this.unsubscribeQuantity();
      if (this.unsubscribeVariant) this.unsubscribeVariant();
    }
    handleProductChange(event) {
      if (!this.contains(event.target)) this.sync();
    }
    handleClick(event) {
      if (this.dataset.required === 'true' || !event.target.closest('[data-gift-clear]')) return;
      this.singleValue = null;
      this.querySelectorAll('[data-gift-radio]').forEach(function (radio) { radio.checked = false; });
      this.setError('');
      this.sync();
    }
    handleChange(event) {
      var option = event.target.closest('[data-gift-option]');
      if (!option) return;
      var radio = option.querySelector('[data-gift-radio]');
      if (event.target.matches('[data-gift-variant]')) {
        var chosen = event.target.options[event.target.selectedIndex];
        radio.value = chosen.value;
        radio.dataset.money = chosen.dataset.money;
        radio.dataset.price = chosen.dataset.price;
        radio.disabled = chosen.dataset.available !== 'true';
        radio.checked = !radio.disabled;
        var price = option.querySelector('[data-gift-price]');
        if (price) price.textContent = chosen.dataset.money;
        option.querySelector('[data-gift-soldout]').hidden = !radio.disabled;
      }
      if (!this.both && radio && radio.checked) this.singleValue = radio.value;
      this.setError('');
      this.sync();
    }
    get both() { return this.dataset.giftBoth === 'true' && this.ratio === 2; }
    get selected() { return this.querySelector('[data-gift-radio]:checked:not(:disabled)'); }
    get ratio() {
      var id = this.form && this.form.querySelector('[name="id"]');
      var count = id && this.quantities[id.value];
      return typeof count === 'number' ? Math.max(0, count) : 1;
    }
    sync() {
      if (!this.form) this.form = document.getElementById(this.dataset.formId);
      var both = this.both;
      var changedMode = this.dataset.bothActive !== String(both);
      this.dataset.bothActive = String(both);
      var singleValue = this.singleValue;
      var radios = Array.from(this.querySelectorAll('[data-gift-radio]'));
      // Reset the whole group before restoring a radio: changing the second
      // checked checkbox into a radio would otherwise uncheck the first one.
      if (changedMode) radios.forEach(function (radio) { radio.checked = false; });
      radios.forEach(function (radio) {
        radio.type = both ? 'checkbox' : 'radio';
      });
      radios.forEach(function (radio) {
        if (both) radio.checked = !radio.disabled;
        else if (changedMode) radio.checked = !radio.disabled && radio.value === singleValue;
      });
      var title = this.querySelector('.taibi-gifts__title');
      if (title) title.textContent = both ? this.dataset.bothTitle : this.singleTitle;
      var legend = this.querySelector('legend');
      if (legend && title) legend.textContent = title.textContent;
      var clear = this.querySelector('[data-gift-clear]');
      if (clear) clear.hidden = both || this.dataset.required === 'true';
      var selected = this.selected;
      this.hidden = this.dataset.active === 'true' && this.ratio === 0;
      var value = this.querySelector('[data-gift-value]');
      if (value) value.textContent = both ? '' : selected ? this.dataset.valueLabel + ' ' + selected.dataset.money : '';
      var note = this.querySelector('[data-gift-quantity]');
      if (note) {
        var quantityInput = this.form && this.form.elements.namedItem('quantity');
        var quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;
        var total = this.ratio * quantity;
        note.hidden = !both && total <= 1;
        note.textContent = both ? Array.from(this.querySelectorAll('[data-gift-radio]')).map(function (radio) {
          return quantity + ' × ' + radio.dataset.title;
        }).join(' + ') : this.dataset.quantityLabel.replace('[quantita]', total);
      }
    }
    setError(message) {
      var error = this.querySelector('[data-gift-error]');
      if (error) { error.hidden = !message; error.textContent = message; }
    }
    prepare(formData) {
      if (this.dataset.active !== 'true' || this.ratio === 0) return null;
      var selected = this.both ? Array.from(this.querySelectorAll('[data-gift-radio]:not(:disabled)')) : this.selected ? [this.selected] : [];
      if (this.both && (Number(this.dataset.giftProductCount) !== 2 || selected.length !== 2)) {
        this.setError(this.dataset.stockError);
        throw new Error(this.dataset.stockError);
      }
      if (!selected.length) {
        if (this.dataset.required !== 'true') return null;
        var available = this.querySelector('[data-gift-radio]:not(:disabled)');
        var message = available ? this.dataset.selectionError : this.dataset.stockError;
        this.setError(message);
        if (available) available.focus();
        throw new Error(message);
      }
      var kitId = formData.get('id');
      if (selected.some(function (gift) { return gift.value === kitId; })) throw new Error(this.dataset.stockError);
      var kitQuantity = parseInt(formData.get('quantity'), 10) || 1;
      var group = 'tg-' + Date.now().toString(36) + '-' + (++sequence).toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var body = new FormData();
      formData.forEach(function (value, name) {
        var property = name.match(/^properties\[(.+)\]$/);
        if (property) body.append('items[0][properties][' + property[1] + ']', value);
        else if (name === 'id' || name === 'quantity' || name === 'selling_plan') body.append('items[0][' + name + ']', value);
        else body.append(name, value);
      });
      body.set('items[0][quantity]', kitQuantity);
      body.set('items[0][properties][Omaggio]', selected.map(function (gift) { return gift.dataset.title; }).join(' + '));
      body.set('items[0][properties][_taibi_gift_group]', group);
      body.set('items[0][properties][_taibi_gift_role]', 'kit');
      body.set('items[0][properties][_taibi_gift_ratio]', this.ratio);
      var plan = selected.map(function (gift) { return { id: gift.value, ratio: selected.length === 2 ? 1 : this.ratio }; }, this);
      body.set('items[0][properties][_taibi_gift_items]', JSON.stringify(plan));
      plan.forEach(function (gift, i) {
        var key = 'items[' + (i + 1) + ']';
        body.set(key + '[id]', gift.id);
        body.set(key + '[quantity]', kitQuantity * gift.ratio);
        body.set(key + '[properties][_taibi_gift_group]', group);
        body.set(key + '[properties][_taibi_gift_role]', 'gift');
        body.set(key + '[properties][_taibi_gift_ratio]', gift.ratio);
      });
      return { body: body, group: group, kitQuantity: kitQuantity, giftItems: plan.map(function (gift) { return { id: gift.id, quantity: kitQuantity * gift.ratio }; }) };
    }
    async add(config, prepared) {
      var cart;
      try {
        var response = await fetch(window.routes.cart_add_url, config);
        var result = await response.json();
        if (!response.ok || result.status) {
          await removeGroup(prepared.group);
          return result.status ? result : { status: response.status, description: this.dataset.stockError };
        }
        cart = await readCart();
        var group = rowsInGroup(cart, prepared.group);
        var gifts = group.filter(function (row) { return row.properties._taibi_gift_role === 'gift'; });
        if (!group.some(function (row) { return row.properties._taibi_gift_role === 'kit' && row.quantity === prepared.kitQuantity; }) || !giftsMatch(gifts, prepared.giftItems)) {
          await removeGroup(prepared.group, cart);
          this.setError(this.dataset.discountError);
          return { status: 422, description: this.dataset.discountError };
        }
        if (result.items && result.items.length) {
          result.id = result.items[0].id;
          result.key = result.items[0].key;
        }
        result.item_count = cart.item_count;
        return result;
      } catch (error) {
        try { await removeGroup(prepared.group); }
        catch (rollbackError) { throw new Error(this.dataset.networkError + ' Controlla il carrello prima di riprovare.'); }
        throw new Error(this.dataset.networkError);
      }
    }
  }
  customElements.define('taibi-gift-picker', TaibiGiftPicker);
})();
